import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import uiData from "./data.json";

const AverageReport = () => {
  const [selectedFirm, setSelectedFirm] = useState(uiData.form.firmButtons[0]);
  const navigate = useNavigate();

  return (
    <div className="w-screen h-screen flex items-center justify-center bg-[#d6c0b6]">
      <div className="w-full h-full border-2 border-black bg-[#f4ebe9] shadow-lg flex flex-col">
        <div className="flex justify-between items-center px-2 py-1 text-xs bg-[#b47c74] text-white">
          <div>{uiData.header.softwareName}</div>
          <div>{uiData.header.contactInfo}</div>
        </div>

        <div className="flex justify-between items-center border-b-2 border-black px-4 py-2">
          <div>
            <div className="text-lg font-bold">{uiData.screenTitle}</div>
            <div className="text-xs">{uiData.subtitle}</div>
          </div>
          <div className="text-center">
            <div className="text-base font-bold">{uiData.reportTitle}</div>
            <div className="text-sm">{uiData.reportDate}</div>
          </div>
        </div>

        <div className="flex px-4 py-3 gap-4">
          <div className="flex-1 flex flex-col gap-3">
            <div className="font-semibold text-sm">
              {uiData.form.labels.filledInfo}
            </div>
            <div className="flex items-center gap-2 text-sm">
              <label>{uiData.form.labels.date}</label>
              <input
                type="text"
                className="border border-black px-2 py-1 text-sm w-40"
                value={uiData.reportDate}
                readOnly
              />
            </div>

            <div className="flex gap-2">
              {uiData.form.firmButtons.map((btn) => (
                <button
                  key={btn}
                  onClick={() => setSelectedFirm(btn)}
                  className={`px-3 py-1 border border-black rounded text-sm font-medium ${selectedFirm === btn ? "bg-[#ffcccc]" : "bg-[#f0f0f0]"
                    }`}
                >
                  {btn}
                </button>
              ))}
            </div>

            <div className="flex flex-col gap-2 text-sm mt-2">
              <label className="flex gap-2 items-center">
                <input type="checkbox" />
                {uiData.form.labels.filters.byName}
              </label>
              <label className="flex gap-2 items-center">
                <input type="checkbox" />
                {uiData.form.labels.filters.byItem}
              </label>
            </div>
          </div>

          <div className="flex items-center justify-center">
            <button className="bg-[#f8f8f8] border border-black px-6 py-8 text-lg font-semibold">
              {uiData.form.showButton}
            </button>
          </div>

          <div className="flex flex-col gap-2">
            {uiData.form.sideButtons.map((btn, idx) => (
              <button
                key={idx}
                disabled={!btn.enabled}
                onClick={
                  btn.label.toLowerCase() === "exit"
                    ? () => navigate("/dashboard")
                    : undefined
                }
                className={`px-3 py-2 border border-black text-sm font-semibold rounded shadow ${btn.enabled
                  ? "bg-[#e4dfd7] hover:bg-[#d6cfc5]"
                  : "bg-gray-300 text-gray-500 cursor-not-allowed"
                  }`}
              >
                {btn.label}
              </button>
            ))}
          </div>
        </div>

        <div className="border-t-2 border-black bg-[#fff5e6] flex-1 flex flex-col">
          <table className="w-full text-sm border-collapse">
            <thead className="bg-[#f0e0cc]">
              <tr>
                {uiData.table.headers.map((head, idx) => (
                  <th
                    key={idx}
                    className="border border-black px-2 py-1 text-left font-semibold"
                  >
                    {head}
                  </th>
                ))}
              </tr>
            </thead>
            <tbody>
              <tr>
                {uiData.table.headers.map((_, idx) => (
                  <td
                    key={idx}
                    className="border border-black px-2 py-6"
                  ></td>
                ))}
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
};

export default AverageReport;